import React from 'react'

export default function Component() {
 return (
   <div>
     <section className="w-full py-12 md:py-24 lg:py-32 bg-green-500 text-white">
       <div className="container px-4 md:px-6">
         <div className="flex flex-col items-center space-y-4 text-center">
           <h1 className="text-3xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none">
             The Plastic Bottle Problem
           </h1>
           <p className="max-w-[600px] text-lg/relaxed">
             Discover the environmental impact of plastic bottles and explore sustainable solutions.
           </p>
         </div>
       </div>
     </section>
     <section className="w-full py-12 md:py-24 lg:py-32 bg-yellow-500 text-white">
       <div className="container px-4 md:px-6">
         <div className="flex flex-col items-center space-y-4 text-center">
           <h2 className="text-2xl font-bold tracking-tighter sm:text-4xl xl:text-5xl/none">Statistics</h2>
           <p className="max-w-[600px] text-lg/relaxed">
             Every minute, one million plastic bottles are purchased worldwide, and that number is set to increase by
             another 20% by 2021.
           </p>
           <div className="w-full flex flex-col md:flex-row gap-4">
             <img
               alt="Statistics Image"
               className="w-full md:w-1/2 h-64 object-cover"
               height="200"
               src="https://1.bp.blogspot.com/-BwSJsllI7SI/Vs7QV0FA2JI/AAAAAAAAH5M/_LougeJf7Xs/s1600/Plastic%2BHas%2BBecome%2BPart%2BOf%2BEarth%2527s%2BGeology.jpg"
               style={{
                 aspectRatio: "200/200",
                 objectFit: "cover",
               }}
               width="200"
             />
             <div className="w-full md:w-1/2 flex flex-col justify-center items-center">
               <h3 className="text-xl font-bold">Did You Know?</h3>
               <p className="text-center">
                 If we lined up all the plastic bottles discarded in a year, they would reach the moon and back 10
                 times.
               </p>
             </div>
           </div>
         </div>
       </div>
     </section>
     <section className="w-full py-12 md:py-24 lg:py-32 bg-red-500 text-white">
       <div className="container px-4 md:px-6">
         <div className="flex flex-col items-center space-y-4 text-center">
           <h2 className="text-2xl font-bold tracking-tighter sm:text-4xl xl:text-5xl/none">Environmental Impact</h2>
           <p className="max-w-[600px] text-lg/relaxed">
             Plastic bottles take 450 years to decompose, causing harm to our ecosystems and contributing to global
             warming.
           </p>
           <div className="w-full flex flex-col md:flex-row gap-4">
             <img
               alt="Environmental Impact Image"
               className="w-full md:w-1/2 h-64 object-cover"
               height="200"
               src="https://www.smi.group/wp-content/uploads/2019/09/SMI-NEWS-plastics-8.png"
               style={{
                 aspectRatio: "200/200",
                 objectFit: "cover",
               }}
               width="200"
             />
             <div className="w-full md:w-1/2 flex flex-col justify-center items-center">
               <h3 className="text-xl font-bold">Fact</h3>
               <p className="text-center">
                 Plastic bottles are among the top five most common types of litter found on beaches.
               </p>
             </div>
           </div>
         </div>
       </div>
     </section>
     <section className="w-full py-12 md:py-24 lg:py-32 bg-blue-500 text-white">
       <div className="container px-4 md:px-6">
         <div className="flex flex-col items-center space-y-4 text-center">
           <h2 className="text-2xl font-bold tracking-tighter sm:text-4xl xl:text-5xl/none">Solutions</h2>
           <p className="max-w-[600px] text-lg/relaxed">
             From recycling to using reusable bottles, there are many ways we can reduce the environmental impact of
             plastic bottles.
           </p>
           <div className="w-full flex flex-col md:flex-row gap-4">
             <img
               alt="Solutions Image"
               className="w-full md:w-1/2 h-64 object-cover"
               height="200"
               src="https://europlas.com.vn/Data/Sites/1/media/10-2023/recycle-plastic-at-home/4.png"
               style={{
                 aspectRatio: "200/200",
                 objectFit: "cover",
               }}
               width="200"
             />
             <div className="w-full md:w-1/2 flex flex-col justify-center items-center">
               <h3 className="text-xl font-bold">Take Action</h3>
               <p className="text-center">
                 Switching to a reusable water bottle can save up to 167 plastic bottles per year.
               </p>
             </div>
           </div>
         </div>
       </div>
     </section>
   </div>
 )
}

